const initialState = {
    cp: "0",
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case "UPDATE_DOCUMENTS_VALUES":
        return { ...state, ...payload }

    default:
        return state
    }
}
